import * as LDClient from 'launchdarkly-js-client-sdk'

// Initialized Context
// Using a recommended pattern by LD to avoid reaching the context limit with anonymous contexts
const initContext = {
  kind: 'initialize',
  key: 'initialize',
}

// Initialize LaunchDarkly client with client-side SDK key and initial context
export const client =
  typeof window === 'undefined'
    ? {}
    : LDClient.initialize(
        window.__LAUNCH_DARKLY__.client_sdk_key,
        initContext,
        { streaming: true }
      )

// https://support.launchdarkly.com/hc/en-us/articles/12998125691419-Error-LaunchDarklyFlagFetchError-network-error-
if (typeof window !== 'undefined') {
  client.on('error', () => {})
}
